"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
exports.default = (actionType, dispatch, message) => {
    dispatch({ type: actionType, message });
    setTimeout(() => dispatch({ type: 'DISMISS_FAILURE' }), 4000);
    if (!index_1.isRunningInIframe() &&
        (message.includes('auth_context') || message.includes('Unauthenticated') || message.includes('Authorised'))) {
        window.location.replace('/auth/sign-in');
    }
};
